export default "__VITE_ASSET__CczB9Jdh__"